import {Card, Collapse, Divider, IconButton, Stack, Typography} from '@mui/material';
import React, {useState} from 'react';
import {ArrowDown} from '@icons/index';
import {Colors} from '@constants/colors.constants';

interface TableCardProps {
  children?: JSX.Element | JSX.Element[];
  icon?: JSX.Element;
  menuOptions?: JSX.Element | JSX.Element[];
  noArrow?: boolean;
  subTitle?: string;
  title: string;
}

const TableCard = (props: TableCardProps) => {
  const {
    children,
    icon,
    menuOptions,
    noArrow,
    subTitle,
    title,
  } = props;

  const [expanded, setExpanded] = useState(false);

  return (
    <Card
      onClick={() => noArrow ? {} : setExpanded(!expanded)}
      sx={{cursor: !noArrow ? 'pointer' : undefined}}
      elevation={0}>
      <Stack px="30px">
        <Stack direction="row" justifyContent="space-between" height="80px">
          <Stack direction="row" alignItems="center" spacing={1.5}>
            {icon}
            <Typography fontSize={20} fontWeight="700">{title}</Typography>
            <Typography fontSize={14} fontWeight="400" color={Colors.textWithOpacity}>{subTitle}</Typography>
          </Stack>
          <Stack direction="row" alignItems="center" mr="-5px">
            {menuOptions}
            {!noArrow && (
              <IconButton disableRipple>
                <ArrowDown style={{height: 11, width: 20}}/>
              </IconButton>
            )}
          </Stack>
        </Stack>
        {expanded && (
          <Divider variant="fullWidth" sx={{borderColor: Colors.background}}/>
        )}
        <Collapse in={expanded} timeout="auto">
          {expanded && children}
        </Collapse>
      </Stack>
    </Card>
  );
};

export default TableCard;
